module.exports = __webpack_public_path__ + "static/media/mountain_unit_infiltration_example.30326466.jpg";